import React from "react";
// Common Components
import { DynamicDropdown, Button, DatePicker } from "src/Components";
// Services
import { getWorkingDaysFilter } from "src/Requests/wrokingCalender";
// Types
import type { IWorkingCalenderSearchParams } from "src/Interfaces/workingCalender";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: IWorkingCalenderSearchParams;
  onSubmit: () => void;
}
const WorkingCalenderSearchParams = ({
  searchParamChangeHandler,
  searchParam,
  onSubmit,
}: IProps) => {
  return (
    <div className="rounded p-3 flex flex-col gap-3 !w-[300px] h-fit mt-6 shadow-[0px_2px_1px_-1px_rgba(0,0,0,0.2),0px_1px_1px_0px_rgba(0,0,0,0.14),0px_1px_3px_0px_rgba(0,0,0,0.12)]">
      <DatePicker
        label="از تاریخ"
        name="from"
        onChange={searchParamChangeHandler}
        value={searchParam?.from}
      />
      <DatePicker
        label="تا تاریخ"
        name="to"
        onChange={searchParamChangeHandler}
        value={searchParam?.to}
      />
      {/* <DynamicDropdown
        dropdown={{
          name: "workingDaysFilterId",
          placeholder: "وضعیت",
        }}
        getData={getWorkingDaysFilter}
        onChange={searchParamChangeHandler}
        value={searchParam?.workingDaysFilterId}
      /> */}
      <Button
        onClick={onSubmit}
        text="جستجو"
        variant="contained"
        className="mt-3 bg-sky-600"
      />
    </div>
  );
};

export default WorkingCalenderSearchParams;
